import state from './state';
import actions from './actions';
import mutations from './mutations';
import getters from './getters';

export default {
  name: 'resetPassword',
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
